import { Link } from 'react-router-dom'
import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'

import { useBizUsers } from '../BizApi'
import { BizUserForm } from '../components/BizUserForm'
import { BizWidget } from '../widgets/BizWidget'

export function BizUserCreateRoute() {
  const { canCreateUser } = useBizUsers()

  if (!canCreateUser) {
    return (
      <Link to=".." className="link">
        <Trans>Back to user list</Trans>
      </Link>
    )
  }
  return (
    <BizWidget title={t`Create new user`}>
      <BizUserForm />
    </BizWidget>
  )
}
